import { JSX, memo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { DropdownDynamic } from 'core-components/library/dropdown'
import { Tooltip } from 'core-components/library/tooltip'

import { contactReassignTranslations } from '../../config/translation'
import { ReassignmentItem } from '../../model/types'

import styles from './ReassignmentItemRow.module.scss'

interface ReassignmentItemRowProps {
  item: ReassignmentItem
  availableContactsSource: any
  renderDropdown: (item: any) => JSX.Element
  onItemChange: (key: string, value: string) => void
  onPreviewClick: (contact: IContact) => void
}

export const ReassignmentItemRow = memo<ReassignmentItemRowProps>(
  ({ item, availableContactsSource, renderDropdown, onItemChange, onPreviewClick }) => (
    <div className={styles.item}>
      <div className={styles.itemName}>{item.displayName}</div>
      <div className={styles.contact}>
        <DropdownDynamic
          classes={{
            controlClasses: {
              root: styles.dropdown,
            },
          }}
          label={<Translation text={contactReassignTranslations.selectContact} />}
          value={item.contact?.contactId || ''}
          source={availableContactsSource}
          onChange={(value) => onItemChange(item.key, value)}
          renderFunction={renderDropdown}
          caption="name"
        />
        <Tooltip tipContent={() => <Translation text={contactReassignTranslations.preview} span />}>
          <Button
            className={styles.eyeButton}
            iconButton="kbase kbase-eye"
            color="white"
            disabled={item.contact === null}
            onClick={() => item.contact && onPreviewClick(item.contact)}
          />
        </Tooltip>
      </div>
    </div>
  )
)

ReassignmentItemRow.displayName = 'ReassignmentItemRow'
